import type { LeadsType } from "app/pages/sales-intelligence/modules/leads-search";
import type { Translatable } from "app/pages/sales-intelligence/types";

export const TOOLTIP_TRANSLATABLE: Record<LeadsType, Translatable> = {
    companies: {
        key: "si.remove-from-list.company.button.tooltip",
    },
    websites: {
        key: "si.multi_selector.tooltip.remove",
    },
};
